module.exports = __webpack_public_path__ + "img/effect.6f823374.png";